import React from "react";
import {
  IngredContainer,
  IngredientsWrap,
  GroupItems,
  GroupTitle,
  GroupItem,
  GroupItemNotes,
  SupItem,
  BlankBlock,
} from "components/RecipeSteps/Preview/styled";

const Ingredients = ({ paid, ingredients, purshased }) => {
  const forbidAccess = !purshased && paid;

  return (
    <IngredContainer>
      {ingredients &&
        ingredients.map((el) => {
          return (
            <IngredientsWrap key={el.id}>
              {ingredients.length > 1 && <GroupTitle>{el.name}</GroupTitle>}
              <GroupItems border={ingredients.length === 1}>
                {el.ingredient &&
                  el.ingredient.map((item) => {
                    const fractalString = item?.piece?.name.split("/");
                    return (
                      <React.Fragment key={item.id}>
                        {!forbidAccess && (
                          <>
                            <GroupItem>
                              {item.qty >= 1 && item.qty}
                              {fractalString && fractalString[0] != "0" ? (
                                <>
                                  <SupItem left={item.qty > 1 ? true : null}>
                                    {fractalString && fractalString[0]}
                                  </SupItem>
                                  /<SupItem right>{fractalString && fractalString[1]}</SupItem>
                                </>
                              ) : (
                                " "
                              )}
                            </GroupItem>
                            <GroupItem column>{item.unit && item.unit.name}</GroupItem>
                          </>
                        )}
                        <GroupItem column={!forbidAccess} area_notes={forbidAccess}>
                          {item.ingredient && item.ingredient.toLowerCase()}
                        </GroupItem>
                        {item.notes && !forbidAccess && (
                          <>
                            <BlankBlock />
                            <GroupItemNotes>{item.notes}</GroupItemNotes>
                          </>
                        )}
                      </React.Fragment>
                    );
                  })}
              </GroupItems>
            </IngredientsWrap>
          );
        })}
    </IngredContainer>
  );
};
export default Ingredients;
